import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import logoNewImage from '../../assets/images/logo_new.png';
import hensImg from '../../assets/images/hens.jpeg';
import css from './AboutUsPage.module.css';

import { Page } from '../../components';
import FallbackPage, { fallbackSections } from './FallbackPage';
import { ASSET_NAME } from './AboutUsPage.duck';
import { camelize } from '../../util/string';
import { getMetadata } from '../PageBuilder/PageBuilder';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import aboutFooterImg from '../../assets/images/aboutFooter.png';

export const AboutUsPageComponent = props => {
  const { pageAssetsData } = props;
  const { meta = {} } = pageAssetsData?.[camelize(ASSET_NAME)]?.data || {};
  const pageMetaProps = getMetadata(meta, 'Article');

  return (
    <Page {...pageMetaProps} scrollingDisabled={props.scrollingDisabled}>
      <div 
        className={css.aboutUsPage} 
        // style={{
        //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
        // }}
      >
        <TopbarContainer />

        {/* Hero Section */}
        <div
          className={css.heroSection}
          style={{
            backgroundImage: `url(${require('../../assets/images/aboutUsHero.png')})`,
          }}
        >
          <div className={css.heroContainer}>
            {/*<img src={logoNewImage} alt="Farmiez Logo" className={css.faqLogo} />*/}
            <h1 className={css.heroTitle}>About Us</h1>
            <p className={css.titleBelowText}>At Farmiez Marketplace, we believe food should be fresh, local, and community-powered.</p>
            <p className={css.contentText}>Born in backyard gardens and small home farms across Virginia, Farmiez began as a simple way for neighbors to share fresh food with one another. What started with backyard growers sharing eggs has grown into a local marketplace connecting people who grow, bake, and produce food with the neighbors who want to enjoy it.</p>
          </div>
          
        </div>

        <div 
          className={css.aboutContentWrap}
          // style={{
          //   backgroundImage: `url(${require('../../assets/images/woodBg.jpg')})`,
          // }}
        >
          {/* Content Section */}
          <div className={css.contentSection}>
            {/*<img src={logoNewImage} alt="Farmiez Logo" className={css.logo} />*/}
            {/*<p className={css.intro}>
              At Farmiez Marketplace, we believe food should be fresh, local, and community-powered.
            </p>
            <p className={css.intro}>
              Born in the backyard coops and kitchen gardens of Virginia, Farmiez is a hyperlocal marketplace connecting everyday growers—like backyard chicken keepers—with neighbors who want better food and a stronger connection to where it comes from.
            </p>*/}
            <div className={css.textBlock}>
              <h3>🌱 We launched with a simple goal</h3>
              <p>Make it easy for neighbors to buy fresh local food from people in their own community. But this is just the beginning.</p>
              <p>We’re building a modern farmers market experience that lives online — one that supports small growers, keeps local dollars in local communities, and helps people reconnect with where their food comes from.</p>
              <p>Whether you're selling vegetables from your garden, herbs from raised beds, baked goods from your kitchen, or fresh eggs from your backyard coop, Farmiez helps you connect with neighbors who value local food.</p>


              <h3>🌿 Our Values</h3>
              <ul>
                <li>🌱 Fresh Local Goods — No shipping, no warehouses — just real food from real people.</li>
                <li>
                  <div className={css.liHead}>🏡 Backyard Raised</div>
                  <div className={css.liText}>We champion small-scale growers, gardeners, and local producers</div>
                </li>
                <li>
                  <div className={css.liHead}>🤝 Community First</div>
                  <div className={css.liText}>Farmiez is built for trust, connection, and transparency between neighbors.</div>
                </li>
              </ul>

              <p>Join the growing movement.</p>
              <p>Let’s bring fresh local food back to the neighborhood.</p>
              <p className={css.greenText}>Welcome to Farmiez Marketplace.</p>
            </div>
          </div>

          <div className={css.footerImgWrap}>
            <img src={aboutFooterImg} alt="img" className={css.footerImg} />
          </div>
        </div>
        <FooterContainer />
      </div>
    </Page>
  );
};

AboutUsPageComponent.propTypes = {
  // pageAssetsData: object,
  // inProgress: bool,
  // error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData } = state.hostedAssets || {};

  return {
    pageAssetsData,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AboutUsPage = compose(connect(mapStateToProps))(AboutUsPageComponent);

export default AboutUsPage;
